import { toast } from "sonner";

export function useToast() {
  return {
    show: (msg) => toast(msg),
  };
}
